<template>
<div class="chapter">
<div class="inner_page">
<div class="illustration" id="illustration">
<p class="paraCenter1"><span class="center"><span class="bold"><em class="italic">List of Illustrations</em></span></span></p>
<p class="paraCenterA"><span class="center">(Appearing between pages 168 and 169)</span></p>
<p class="paraCenterB-1"><span class="center">THE AUTHOR, 1918</span></p>
<p class="paraCenterB-1"><span class="center">FAMOUS GERMAN AIR FIGHTERS AND MR. FOKKER</span></p>
<p class="paraCenter"><span class="center">Fokker, Udet, von Scheich, von Richthofen, Immelman, Boelcke, Voss</span></p>
<p class="paraCenterB"><span class="center">BALLOON STRAFFING</span></p>
<p class="paraCenterB-1"><span class="center">FAMOUS BRITISH AIR FIGHTERS</span></p>
<p class="paraCenter"><span class="center">Maxwell, Rees, Mulholland, Hawker, Lloyd, Windsor, MacDonald, Baker</span></p>
<p class="paraCenterB-1"><span class="center">FAMOUS BRITISH AIR FIGHTERS</span></p>
<p class="paraCenter"><span class="center">Van Ryneveld, Rhys-David, Longcroft, Ball, Kinkead, Caldwell, Strange</span></p>
<p class="paraCenterB-1"><span class="center">H.M. THE KING CHATTING TO PILOTS OF NO. 74 SQUADRON</span></p>
<p class="paraCenterB-1"><span class="center">FAMOUS BRITISH AIR FIGHTERS</span></p>
<p class="paraCenter"><span class="center">Sowrey, Beauchamp-Proctor, Barker, McCudden, Bowman, Crowe, Dallas</span></p>
<p class="paraCenterB-1"><span class="center">FAMOUS FRENCH AIR FIGHTERS</span></p>
<p class="paraCenter"><span class="center">Guynemer, Nungessor, Dormé, Madon, Foncke, Coppens</span></p>
<p class="paraCenterB-1"><span class="center">VOSS’S LAST FIGHT</span></p>
<p class="paraCenterB-1"><span class="center">THE AUTHOR</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofAirfighters_illustration.vue?360c2c82